var soj = require('./soj.js');
var util = require('./util')

var ajksoj = {};

ajksoj.install = function (Vue, options) {
    Vue.prototype.$soj = soj;

    Vue.directive('data-trace', function (el, binding) {
        var _this = this;
        var defaults = {
            delay: 50,
            pageName: soj.pageName,
            prefix: 'Exp_'
        };
        var val = binding.value;
        var dataCache = [];
        if (!val) {
            return;
        }
        window.addEventListener('scroll', trace);
        trace();

        function trace() {
            if (el.dataset.traced && el.dataset.traced == 1) {
                window.removeEventListener('scroll', trace);
                return;
            }
            Vue.nextTick(function () {
                if (isElementInViewPort()) {
                    dataCache.push(val);
                    el.dataset.traced = 1;
                    buildData()
                }
            });
        }

        function isElementInViewPort() {
            var rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                || (rect.top < 0 && rect.bottom > 0)
            )
        }

        function buildData() {
            var result = {},
                r = [],
                epData = [],
                exp,
                key,
                length,
                tar = {},
                i;
            /**
             * "{aa:'123'}"
             * 这种格式的数据JSON.parse解析不了，必须用eval才能转成json
             */
            if (dataCache.length == 0) { // 如果没有数据就不发送
                return;
            }

            for (i = 0, length = dataCache.length; i < length; i++) {
                for (key in dataCache[i]) {
                    if (!result[key] && key != 'tid') {
                        result[key] = [];
                    }
                    if (!epData[key] && key == 'tid') {
                        epData[key] = [];
                    }
                    if (key == 'tid') {
                        epData.push(dataCache[i]['entity_id'] + ',' + dataCache[i]['tid']);
                    } else if (key != 'tid' && key != 'entity_id') {
                        result[key].push(dataCache[i][key]);
                    }
                }
            }

            dataCache = [];
            tar.exposure = result;

            var epParams = epData.length > 0 ? {
                'tid': epData.join('|')
            } : {};
            soj.trackEvent(defaults.prefix + soj.pageName || defaults.pageName, JSON.stringify(tar), 3, epParams);
        }
    });

    Vue.directive('data-from', function (el, binding) {
        el.addEventListener('click', bindfrom);
        var val = binding.value;

        function bindfrom(e) {
            var href = el.getAttribute('href');
            if (!href) { // 此处链接不做合法性检查
                return;
            }
            if (/javascript|tel|history.back/i.test(href)) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            if (!val) { // 如果无soj,直接跳转
                location.href = href;
                return;
            }
            if (href.indexOf('?') !== -1) {
                location.href = href + '&from=' + val;
            } else {
                location.href = href + '?from=' + val;
            }
        }
    });
    // 新增traceExp将原来的发到cp中的曝光码改到action中,参数从ep中取 2021.1.9
    Vue.directive('data-traceExp', function (el, binding) {
        var _this = this;
        var defaults = {
            delay: 50,
            pageName: soj.pageName,
            prefix: 'Exp_'
        };
        var val = binding.value;
        var dataCache = [];
        if (!val) {
            return;
        }
        window.addEventListener('scroll', trace);
        trace();

        function trace() {
            if (el.dataset.traced && el.dataset.traced == 1) {
                window.removeEventListener('scroll', trace);
                return;
            }
            Vue.nextTick(function () {
                if (isElementInViewPort()) {
                    dataCache.push(val);
                    el.dataset.traced = 1;
                    buildData()
                }
            });
        }

        function isElementInViewPort() {
            var rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                || (rect.top < 0 && rect.bottom > 0)
            )
        }

        function buildData() {
            var result = {},
                r = [],
                epData = [],
                exp,
                key,
                length,
                tar = {},
                i;
            /**
             * "{aa:'123'}"
             * 这种格式的数据JSON.parse解析不了，必须用eval才能转成json
             */
            if (dataCache.length == 0) { // 如果没有数据就不发送
                return;
            }

            for (i = 0, length = dataCache.length; i < length; i++) {
                for (key in dataCache[i]) {
                    if (!result[key] && key != 'tid') {
                        result[key] = [];
                    }
                    if (!epData[key] && key == 'tid') {
                        epData[key] = [];
                    }
                    if (key == 'tid') {
                        epData.push(dataCache[i]['entity_id'] + ',' + dataCache[i]['tid']);
                    } else if (key != 'tid' && key != 'entity_id') {
                        result[key].push(dataCache[i][key]);
                    }
                }
            }

            dataCache = [];
            tar.exposure = result;

            var epParams = epData.length > 0 ? {
                'tid': epData.join('|')
            } : val;
            soj.trackEvent(val.action || val.name || val.pageName || defaults.prefix + soj.pageName || defaults.pageName, JSON.stringify(tar), 3, epParams);
        }
    });

    function bindnpv(val, e) {
        e.stopPropagation();
        if (typeof val == 'string') {
            soj.trackEvent(val);
            return;
        }
        try {
            if (util.isPlainObject(val)) {
                soj.trackEvent(val.name, val.cp, val.type);
            }
        } catch (e) {
            console.log('npv format wrong!')
        }
    }

    Vue.directive('data-npv', {
        bind(el, binding) {
            var val = binding.value;
            el.onclick = bindnpv.bind(this, val);
        },
        unbind(el) {
            el.onclick = null;
        },
        update(el, binding) {
            var val = binding.value;
            // 如果值改变了，则重新绑定事件
            if (binding.oldValue !== val) {
                el.onclick = bindnpv.bind(this, val);
            }
        }
    });
}
module.exports = ajksoj;
